/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Add_PeopleInputs */

const cs_chat_add_people = /** @type {(inputs: Chat_Add_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přidat lidi`)
};

const en_chat_add_people = /** @type {(inputs: Chat_Add_PeopleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add people`)
};

/**
* | output |
* | --- |
* | "Add people" |
*
* @param {Chat_Add_PeopleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const chat_add_people = /** @type {((inputs?: Chat_Add_PeopleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Add_PeopleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_chat_add_people(inputs)
	return cs_chat_add_people(inputs)
});